import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { DevSeederService, SeedUserRequest } from '../services/dev-seeder.service';

@Component({
	selector: 'app-dev-panel',
	templateUrl: './dev-panel.component.html',
	styleUrls: ['./dev-panel.component.css'],
	standalone: false,
})
export class DevPanelComponent implements OnInit {
	private devSeeder = inject(DevSeederService);
	private authorizeService = inject(AuthorizeService);
	private router = inject(Router);

	collapsed = true;
	loading = false;
	resultMessage = 'Ready.';
	resultIsError = false;

	tradingPartners: { tradingPartnerID: number; name: string }[] = [];
	vendors: { vendorID: number; name: string }[] = [];

	form: SeedUserRequest = {
		email: 'test@local.dev',
		password: 'DevPassword1!',
		firstName: 'Test',
		lastName: 'User',
		userType: 'IchraXUser',
		tradingPartnerID: null,
		vendorID: null,
		signInAfterSeed: true,
	};

	resetForm = { email: '', newPassword: '' };
	resetLoading = false;
	resetResultMessage = '';
	resetResultIsError = false;

	ngOnInit(): void {
		const stored = sessionStorage.getItem('devPanelCollapsed');
		if (stored !== null) {
			this.collapsed = stored === 'true';
		}

		this.devSeeder.getTradingPartners().subscribe({
			next: (list) => (this.tradingPartners = list),
		});
		this.devSeeder.getVendors().subscribe({
			next: (list) => (this.vendors = list),
		});
	}

	toggleCollapse(): void {
		this.collapsed = !this.collapsed;
		sessionStorage.setItem('devPanelCollapsed', String(this.collapsed));
	}

	onUserTypeChange(): void {
		this.form.tradingPartnerID = null;
		this.form.vendorID = null;
	}

	resetPassword(): void {
		this.resetLoading = true;
		this.resetResultIsError = false;
		this.resetResultMessage = 'Resetting...';

		this.devSeeder.resetPassword(this.resetForm.email, this.resetForm.newPassword).subscribe({
			next: (response) => {
				this.resetLoading = false;
				this.resetResultMessage = response.message;
				this.resetForm.newPassword = '';
			},
			error: (err) => {
				this.resetLoading = false;
				this.resetResultIsError = true;
				const msg = err?.error?.message ?? JSON.stringify(err?.error ?? err);
				this.resetResultMessage = msg;
			},
		});
	}

	seed(): void {
		this.loading = true;
		this.resultIsError = false;
		this.resultMessage = 'Seeding...';

		this.devSeeder.seedUser(this.form).subscribe({
			next: (response) => {
				this.loading = false;
				this.resultMessage = response.message;
				this.authorizeService.refreshSession().subscribe(() => {
					this.router.navigate(['/dashboard']);
				});
			},
			error: (err) => {
				this.loading = false;
				this.resultIsError = true;
				const msg = err?.error?.message ?? JSON.stringify(err?.error ?? err);
				this.resultMessage = msg;
			},
		});
	}
}
